import React, {useEffect, useState} from "react";
import {fetchAds} from "../../../util/ad_api_utils";

import {matchPath, useHistory, useLocation} from "react-router-dom";
import {showToast} from "../../../actions/toast_actions";
import {connect} from "react-redux";
import {AdModalForm} from "./AdModalForm";

const AdModal = ({pagesToShowOn, showToast, currentUser}) => {
  const [ads, setAds] = useState([])
  const [selectedAd, setSelectedAd] = useState(null)
  const history = useHistory()
  const location = useLocation()
  const [shouldShowOnCurrentPage, setShouldShowOnCurrentPage] = useState(false)
  const [show, setShow] = useState(false)
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('adSlideOutDismissed') === 'true')
  const [popupDismissed, setPopupDismissed] = useState(() => sessionStorage.getItem('adPopupDismissed') === 'true')
  // const show_two_modals = matchPath(location.pathname, { path: "/book-shoot", exact: true }) || matchPath(location.pathname, { path: "/book", exact: true })
  const show_two_modals = true
  const [currentAdType, setCurrentAdType] = useState("popup");

  const isSlideOutOnly = (location) => {
    return pagesToShowOn.some(page => page.slide_out_only && matchPath(location.pathname, { path: page.path, exact: page.exact }))
  }

  useEffect(() => {
    calculateWhetherToShow(location)
    if (isSlideOutOnly(location) || sessionStorage.getItem('adPopupDismissed') === 'true') setCurrentAdType("slide_out")

    history.listen((location) => {
      calculateWhetherToShow(location)
      const popupGone = sessionStorage.getItem('adPopupDismissed') === 'true'
      setCurrentAdType((isSlideOutOnly(location) || popupGone) ? "slide_out" : "popup")
    });

    fetchAds().then(setAds)
  }, [])

  useEffect(() => {
    if (!shouldShowOnCurrentPage) {
      setSelectedAd(null)
      setShow(false)
    }
  }, [shouldShowOnCurrentPage])

  useEffect(() => {
    if (!shouldShowOnCurrentPage) return
    if (ads.length === 0) return
    if (dismissed) return
    if (popupDismissed && currentAdType === "popup") {
      setCurrentAdType("slide_out")
      return
    }

    let showable_ads = ads.filter(ad => !ad.book_shoot_page);

    // if (matchPath(location.pathname, { path: "/book-shoot", exact: true })) {
    //   showable_ads = ads.filter(ad => ad.book_shoot_page)
    // }

    if (currentAdType) {
      showable_ads = showable_ads.filter(ad => ad.ad_type === currentAdType);
    }

    if (showable_ads.length === 0) {
      setSelectedAd(null)
    }

    const ad = showable_ads[Math.floor(Math.random() * showable_ads.length)];
    setSelectedAd(ad)

    const interval = setTimeout(() => {
      setShow(true)
    }, 5000)

    return () => clearInterval(interval)
  }, [ads, shouldShowOnCurrentPage, currentAdType, dismissed, popupDismissed])

  const calculateWhetherToShow = (location) => {
    setShouldShowOnCurrentPage(pagesToShowOn.some(page => {
      if (currentUser || page.dontShowAd) {
        return false
      }
      return matchPath(location.pathname, {path: page.path, exact: page.exact})
    }))
  }

  const onClose = (e) => {
    e.preventDefault()
    setShow(false)
    if (show_two_modals && currentAdType === "popup") {
      setPopupDismissed(true)
      sessionStorage.setItem('adPopupDismissed', 'true')
      setCurrentAdType("slide_out");
      setTimeout(() => {
        setShow(true);
      }, 2000); // Adjust the delay as needed
    } else {
      setDismissed(true)
      sessionStorage.setItem('adSlideOutDismissed', 'true')
    }
  }

  const onSubscribed = () => {
    setShow(false)
  }

  if (!selectedAd) return <></>

  const type = selectedAd.description ? 'vertical' : 'horizontal'
  const isVertical = type === 'vertical'
  const imageUrl = selectedAd.image?.url

  return (<AdModalForm showToast={showToast} title={selectedAd.title} description={selectedAd.description}
                 button_text={selectedAd.button_text}
                 imageUrl={imageUrl}
                 isVertical={isVertical}
                 adId={selectedAd.id}
                 coupon_code={selectedAd.coupon_code}
                 ad_type={selectedAd.ad_type}
                 onClose={onClose}
                 show={show}
                 type={type}
                 onSubscribed={onSubscribed}
    />)
}

const msp = (state) => ({
  currentUser: state.session.currentUser ? state.entities.users[state.session.currentUser.id] : null
});

const mdp = (dispatch) => ({
  showToast: (message) => dispatch(showToast(message))
});

export default connect(msp, mdp)(AdModal);
